import React from 'react';
import { ShoppingCartIcon, CheckCircleIcon } from 'lucide-react';
export function BabyCTASection() {
  return <section id="comprar" className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-baby-blue-light via-baby-lavender to-baby-pink-light" data-id="element-44">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-45">
        <div className="bg-white/95 backdrop-blur-baby p-6 sm:p-8 md:p-10 lg:p-12 rounded-baby-lg shadow-baby-glow text-center border-2 border-baby-lavender animate-fade-in-up" data-id="element-46">
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-3 sm:mb-4 md:mb-6 bg-gradient-to-r from-baby-pink via-baby-lavender to-baby-blue bg-clip-text text-transparent" data-id="element-47">
            Mientras imaginas una semana sin improvisar...
          </h2>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-4 sm:mb-6 md:mb-8 text-gray-700" data-id="element-48">
            Mientras sientes cómo sería tenerlo todo claro...
          </p>

          <div className="bg-gradient-to-br from-baby-blue-light to-baby-pink-light p-5 sm:p-6 md:p-8 rounded-baby border-2 border-baby-lavender mb-6 sm:mb-8" data-id="element-49">
            <p className="text-lg sm:text-xl md:text-2xl font-bold mb-3 sm:mb-4 text-gray-900" data-id="element-50">
              Haz clic ahora.
            </p>
            <p className="text-sm sm:text-base md:text-lg text-gray-700 mb-2" data-id="element-51">
              Ve el método paso a paso.
            </p>
            <p className="text-sm sm:text-base md:text-lg text-gray-700" data-id="element-52">
              Organiza la comida de tu bebé desde hoy.
            </p>
          </div>

          <a href="https://mikioscodigital.com/cart/51716038885657:1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-baby-gradient-pink-blue text-white px-6 py-3 sm:px-8 sm:py-4 md:px-10 md:py-5 rounded-baby-lg font-extrabold text-base sm:text-lg md:text-xl hover:shadow-baby-glow active:scale-95 transition-all mb-4 sm:mb-6 w-full sm:w-auto" style={{
          textShadow: '0 2px 4px rgba(0,0,0,0.3)'
        }} data-id="element-53">
            <ShoppingCartIcon className="w-5 h-5 sm:w-6 sm:h-6 mr-2" data-id="element-54" />
            Comprar Ahora - $9.95
          </a>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 md:gap-6 text-xs sm:text-sm md:text-base text-gray-700" data-id="element-55">
            <div className="flex items-center gap-2" data-id="element-56">
              <CheckCircleIcon className="w-4 h-4 sm:w-5 sm:h-5 text-baby-blue flex-shrink-0" data-id="element-57" />
              <span data-id="element-58">Descarga Instantánea</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-59">
              <CheckCircleIcon className="w-4 h-4 sm:w-5 sm:h-5 text-baby-pink flex-shrink-0" data-id="element-60" />
              <span data-id="element-61">Garantía 30 Días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-62">
              <CheckCircleIcon className="w-4 h-4 sm:w-5 sm:h-5 text-baby-lavender flex-shrink-0" data-id="element-63" />
              <span data-id="element-64">Pago Seguro</span>
            </div>
          </div>

          <p className="mt-4 sm:mt-6 text-sm sm:text-base md:text-lg italic text-gray-600" data-id="element-65">
            Tú pones el amor. Este ebook pone el plan.
          </p>
        </div>
      </div>
    </section>;
}